import React from 'react';
import { PAYMENTS } from 'state/payment/type';
import { cn } from 'lib/utils';

interface props {
  info: PAYMENTS.IGatewayTransaction;
}

const GatewayPaymentMethod = ({
  info = {} as PAYMENTS.IGatewayTransaction,
}: props): JSX.Element => {
  const decodedAccountName = info?.account_name
    ? decodeURIComponent(info?.account_name).trim()
    : 'NA';

  return (
    <>
      <div className="mb-9 pb-2">
        <h3 className="mb-2 text-xl font-semibold leading-7 text-gray-blue-80">
          Payment method
        </h3>
        <hr className="mt-0 pb-1 mb-2" />
        <div>
          <div className="py-1 pt-0">
            <span className="text-gray-blue-50 text-sm leading-5 font-normal mr-4 min-w-48 max-w-60 inline-block">
              Method
            </span>
            <span className="text-gray-blue-80 text-sm leading-5 font-normal">
              {info.method}
            </span>
          </div>
          <div className="py-1">
            <span className="text-gray-blue-50 text-sm leading-5 font-normal mr-4 min-w-48 max-w-60 inline-block">
              Card Issuer / Bank / Wallet
            </span>
            <span className="text-gray-blue-80 text-sm leading-5 font-normal">
              {/* {decodedAccountName} */}
              {'NA'}
            </span>
          </div>
          <div className="py-1 pb-0">
            <span className="text-gray-blue-50 text-sm leading-5 font-normal mr-4 min-w-48 max-w-60 inline-block">
              Account / Card Number
            </span>
            <span className="text-gray-blue-80 text-sm leading-5 font-normal">
              {info.account_number || 'NA'}
            </span>
          </div>
          <div className="py-1 pb-0">
            <span className="text-gray-blue-50 text-sm leading-5 font-normal mr-4 min-w-48 max-w-60 inline-block">
              Payment Partner
            </span>
            <span className="text-gray-blue-80 text-sm leading-5 font-normal">
              {info.processor_name}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default GatewayPaymentMethod;
